
export const actionTypes = {
	GET_MAINTENANCE_SCHEDULE_SETTINGS: 'sensorfirmwaremanagement/edit/GET_MAINTENANCE_SCHEDULE_SETTINGS',
	ADD_MAINTENANCE_SCHEDULE_SETTINGS: 'sensorfirmwaremanagement/edit/ADD_MAINTENANCE_SCHEDULE_SETTINGS',
	CLEAR_STORE: 'sensorfirmwaremanagement/edit/CLEAR_STORE',
	GET_MAINTENANCE_SCHEDULE_SETTINGS_MICRO_SERVICE: 'sensorfirmwaremanagement/edit/GET_MAINTENANCE_SCHEDULE_SETTINGS_MICRO_SERVICE',

	//saga
	GET_MAINTENANCE_SCHEDULE_REQUEST: 'sensorfirmwaremanagement/edit/GET_MAINTENANCE_SCHEDULE_REQUEST',
	ADD_MAINTENANCE_SCHEDULE_REQUEST: 'sensorfirmwaremanagement/edit/ADD_MAINTENANCE_SCHEDULE_REQUEST',
};
